import {
  CardSide,
  HealthPlanCardUploadResponse,
  OcrPollResponse,
} from '@lyrahealth-inc/shared-app-logic/src/features/healthPlan/types/healthPlanCardUpload'
import {
  HealthPlanInfo,
  Patient,
  PaymentHistory,
  PaymentMethods,
  PostHealthPlanPaymentInfoBody,
  PostSelfPayPaymentInfoBody,
} from '@lyrahealth-inc/shared-app-logic/src/models/healthPlan/HealthPlan'

import { axiosInstance } from '../axiosInstance'

export function submitHealthPlanInfoData(lyraId: string, data: HealthPlanInfo) {
  return axiosInstance.post<Patient>(`/v1/patient/${lyraId}/healthplan-info`, data)
}

export function getPatientData(lyraId: string) {
  return axiosInstance.get<Patient>(`/v1/patient/${lyraId}`)
}

/**
 * Upload health plan card image for OCR processing
 */
export function uploadHealthPlanCardData(lyraId: string, file: File, cardSide: CardSide) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('cardSide', cardSide)

  return axiosInstance.post<HealthPlanCardUploadResponse>(`/v1/patient/${lyraId}/healthplan-info/upload`, formData)
}

/**
 * Poll for OCR results after health plan card upload
 */
export function pollHealthPlanCardOcrData(lyraId: string, taskId: string) {
  return axiosInstance.get<OcrPollResponse>(`/v1/patient/${lyraId}/healthplan-info/upload/${taskId}`)
}

export function removeHealthPlanInfoData(lyraId: string, isSecondary: boolean) {
  const params = isSecondary ? { secondary: true } : undefined
  return axiosInstance.delete(`/v1/patient/${lyraId}/healthplan-info`, { params })
}

export function submitHealthPlanPaymentData(lyraId: string, data: PostHealthPlanPaymentInfoBody) {
  return axiosInstance.post<Patient>(`/v1/patient-payment-method/cost-sharing/user/${lyraId}`, data)
}

export function submitSelfPayPaymentData(lyraId: string, data: PostSelfPayPaymentInfoBody) {
  return axiosInstance.post<Patient>(`/v2/patient-payment-method/SELF_PAY/user/${lyraId}`, data)
}

export function removeHealthPlanPaymentData(lyraId: string) {
  return axiosInstance.delete(`/v1/patient-payment-method/cost-sharing/user/${lyraId}`)
}

export function getHealthPlanPaymentData(lyraId: string) {
  return axiosInstance.get<PaymentMethods>(`/v1/patient-payment-method/user/${lyraId}`)
}

export function getHealthPlanPaymentDataV2(lyraId: string) {
  return axiosInstance.get<PaymentMethods>(`/v2/patient-payment-method/user/${lyraId}`)
}

export function getPaymentHistoryData(lyraId: string) {
  return axiosInstance.get<PaymentHistory[]>(`/v1/patient/${lyraId}/transfers`)
}

export function downloadPaymentsData(lyraId: string) {
  return axiosInstance.get<string>(`/v1/patient/${lyraId}/transfers/csv`)
}

export function getEligibilityData() {
  return axiosInstance.get(`/v1/patient/eligibilityoptions`)
}
